import React from "react";
import { useTranslation } from "react-i18next";
import LegalPageLayout, {
  LegalLead,
  LegalList,
  LegalSection,
  LegalText,
} from "./LegalPageLayout";

const RefundPolicy: React.FC = () => {
  const { t } = useTranslation();
  const h = (n: number) => t(`legal.refund.h${n}`);
  return (
    <LegalPageLayout title={t("legal.refund.title")} lastUpdated="2026-08-31">
      <p>{t("legal.refund.intro")}</p>

      <LegalSection heading={h(1)}>
        <p>
          <LegalText k="legal.refund.p1" />
        </p>
        <LegalList
          items={["a", "b", "c"].map((x) => t(`legal.refund.l1${x}`))}
        />
      </LegalSection>

      <LegalSection heading={h(2)}>
        <LegalList
          items={["a", "b", "c", "d"].map((x) => (
            <LegalLead key={x} k={`legal.refund.l2${x}`} />
          ))}
        />
      </LegalSection>

      <LegalSection heading={h(3)}>
        <p>
          <LegalText k="legal.refund.p3" />
        </p>
      </LegalSection>

      <LegalSection heading={h(4)}>
        <p>{t("legal.refund.p4")}</p>
      </LegalSection>

      <LegalSection heading={h(5)}>
        <p>{t("legal.refund.p5")}</p>
      </LegalSection>

      <LegalSection heading={h(6)}>
        <p>
          <LegalText k="legal.refund.p6" />
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
};

export default RefundPolicy;
